import { FADE_MASK_STYLE } from "@/utils/masonryMask"

interface BrowserMockupProps {
  height?: string | number
  showFadeGradients?: boolean
  url?: string
  favicon?: string
  children: React.ReactNode
}

export function BrowserMockup({
  height = "280px",
  showFadeGradients = true,
  url,
  favicon,
  children,
}: BrowserMockupProps) {
  const heightValue = typeof height === "number" ? `${height}px` : height

  return (
    <div className="bg-bg-surface border border-solid border-border-default rounded-xl overflow-hidden">
      <div className="relative flex items-center gap-2 px-4 py-3 bg-bg-surface/60 border-b border-border-default">
        {/* Window controls */}
        <div className="flex items-center gap-1.5">
          <div className="w-3 h-3 rounded-full border border-solid border-border-default" />
          <div className="w-3 h-3 rounded-full border border-solid border-border-default" />
          <div className="w-3 h-3 rounded-full border border-solid border-border-default" />
        </div>
        {/* URL bar - centered */}
        {(url || favicon) && (
          <div className="absolute left-1/2 -translate-x-1/2 flex items-center gap-2 rounded-full px-1 py-0.5">
            {favicon && (
              <img
                src={favicon}
                alt=""
                className="w-4 h-4 shrink-0 rounded-full border border-solid border-border-default bg-white"
              />
            )}
            {url && <span className="text-xs text-fg-secondary/50 truncate">{url}</span>}
          </div>
        )}
      </div>

      <div
        className="relative border-t border-l border-solid border-border-default bg-bg-default"
        style={{
          overflow: "hidden",
          height: height === "auto" ? "auto" : heightValue,
          ...(showFadeGradients ? FADE_MASK_STYLE : {}),
        }}
      >
        {children}
      </div>
    </div>
  )
}
